export const ARBEITNEHMER_TYP = [
  'VOLLZEIT',
  'TEILZEIT',
  'AZUBI',
  'MIDIJOB',
  'MINIJOB',
  'KURZ_MIT_LSTK',
  'KURZ_OHNE_LSTK',
  'WERKSTUDENT',
  'PRAKTIKANT',
  'SELBSTSTAENDIG',
  'EHRENAMTLICH',
] as const;

export type ArbeitnehmerTyp = (typeof ARBEITNEHMER_TYP)[number];

export function isArbeitnehmerTyp(value: string): value is ArbeitnehmerTyp {
  return (ARBEITNEHMER_TYP as readonly string[]).includes(value);
}
